<div class="see-more-container" #seeCardContainer>
    <div #header class="see-card-container">
        <div >
            <div class="row mb-2">
                <div class="col-12 align-items-center">
                    <button type="button" class="p-0 p-2 button-container-smc btn btn-text-gray btn-icon" (click)="updatedCurrentView()">
                        <svg class="button-icon">
                            <use href="../App_Themes/clearview-default/icons/utility/arrow-left.svg#arrow-left"></use>
                        </svg>
                        <span class="back-button" cvLocalizedText langSection="Common" langKey="Back_Button">Back</span>
                    </button>
                </div>
            </div>
            <div class="row mb-1">
                <div class="col-12 d-flex align-items-center">
                    <span class="name" #agentText
                    [tooltip]="checkTextTruncation(agent?.GroupName, 'name-tooltip')" placement="top" 
                    container="body" containerClass="tooltip-custom-see-more"
                    (mouseenter)="tooltipAgent.show()" 
                    triggers="manual"
                    #tooltipAgent="bs-tooltip"
                    (mouseleave)="tooltipAgent.hide()"
                    (wheel)="tooltipAgent.hide()">{{ agent?.GroupName }}</span>
                    <span class="separator">|</span>
                    <span class="team" #agentTeamText
                    [tooltip]="checkTextTruncation(agent?.TeamName, 'team-tooltip')" placement="top" 
                    container="body" containerClass="tooltip-custom-see-more"
                    (mouseenter)="tooltipAgentTeam.show()" 
                    triggers="manual"
                    #tooltipAgentTeam="bs-tooltip"
                    (mouseleave)="tooltipAgentTeam.hide()"
                    (wheel)="tooltipAgentTeam.hide()">{{ agent?.TeamName }}</span>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-4 pr-0 align-items-center">
                    <span class="agent-card-label">{{ getLocalizationString("Total_Games", "Total Games") }}: </span>
                    <span class="agent-card-text" #totalGames
                    [tooltip]="checkTextTruncation(cvNumberLocalizePipe?.transform(agent?.ActiveGameCount), 'total-games-tooltip')" placement="top" 
                    container="body" containerClass="tooltip-custom-see-more"
                    (mouseenter)="tooltipTotalGames.show()" 
                    triggers="manual"
                    #tooltipTotalGames="bs-tooltip"
                    (mouseleave)="tooltipTotalGames.hide()"
                    (wheel)="tooltipTotalGames.hide()"> {{ cvNumberLocalizePipe?.transform(agent?.ActiveGameCount) }}</span>
                </div>
                <div class="col-8 pl-0 pl-4">
                    <span #coinsTooltipText class="earning-text">
                        <span class="agent-card-label agent-card">{{ getLocalizationString("Total_Earned_Coin", "Total Earned Coins") }}: </span>                        
                        <span class="agent-card-text" #totalCoins
                        [tooltip]="checkTextTruncation(cvNumberLocalizePipe?.transform(agent?.AvailableCoins), 'total-coins-tooltip')" placement="top" 
                        container="body" containerClass="tooltip-custom-see-more"
                        (mouseenter)="tooltipTotalCoins.show()" 
                        triggers="manual"
                        #tooltipTotalCoins="bs-tooltip"
                        (mouseleave)="tooltipTotalCoins.hide()"
                        (wheel)="tooltipTotalCoins.hide()">
                        <span class="mr-1">
                            <svg class="icon-16">
                                <use href="../../../App_Themes/CXone/icons/gamification/games/coin-reward.svg#coin-reward"></use>
                            </svg>
                        </span> {{ cvNumberLocalizePipe?.transform(agent?.AvailableCoins) }}</span>
                    </span>
                </div>
            </div>
        </div>
    </div>
    <overlay-scrollbars 
    [style.height]="retrievedCurrentView() === viewType.cardView ? '0%' : scrollSize+'px'"
    [options]="retrievedCurrentView() === viewType.cardView ? hiddenScrollOptions : scrollOptions"
    class="scrollbar" [ngClass]="{'small-scroll': isWidgetSmall}">
        <div [hidden]="noData && isDataLoading" class="error-container">
            <svg class="error-icon">
                <use href="../App_Themes/CXone/icons/empty.svg#empty"></use>
            </svg>
            <p class="cxone-error-text" cvLocalizedText langSection="Games_Module" langKey="CXone_Game_Data_Error">No game assigned</p>
        </div>
        <div [hidden]="!noData && !isDataLoading" class="" container="body">
            <!-- here would be agent's games    -->
        </div>
    </overlay-scrollbars>
</div>
